import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconEmpty from '../../../assets/Images/icons/empty';
import likeliHoodImpact from '../../../assets/Images/svg/likeliHood/likelihood-impact-img.svg';
import { DEFINITIONS_ID } from '../DEFINITIONS_ID';
import UserService from '../../../services/UserService';
import { ROUTER } from '../../../constants/router';
import usePermission from '../../../hooks/usePermission';

export default function Tab3({ detail, definition }) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    let { riskId } = useParams();
    const [raDetail, setRaDetail] = useState();
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const { isAuditor } = usePermission();

    useEffect(() => {
        if (detail?.likelihood) {
            setRaDetail(detail.likelihood[0]);
        }
    }, [detail]);

    const levelColor = (id) => {
        switch (id) {
            case DEFINITIONS_ID.GREEN:
                return '#A7D17E';
            case DEFINITIONS_ID.YELLOW:
                return '#FFD15C';
            case DEFINITIONS_ID.ORANGE:
                return '#EA8A54';
            case DEFINITIONS_ID.RED:
                return '#CD5D4A';
            case DEFINITIONS_ID.CRIMSON:
                return '#A3402F';
            default:
                return '#ECECEC';
        }
    };

    return (
        <div className="p-4">
            <div className="mb-4" style={{ borderBottom: '3px solid #F4F6FC' }}>
                <div className="flex justify-between">
                    <div className="flex space-x-2 items-center pb-2">
                        <div className="text-2xl font-bold pb-1">
                            {t('RA.Likelihood')}
                        </div>
                        <Tooltip
                            overlayStyle={{
                                minWidth: '18%',
                            }}
                            placement="rightTop"
                            title={t('Tooltip.Likelihood')}
                        >
                            <a className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm">
                                <ExclamationCircleOutlined />
                            </a>
                        </Tooltip>
                    </div>
                    <div>
                        <Button
                            disabled={isAuditor}
                            hidden={!admin}
                            type="primary"
                            style={{ padding: '0px 30px' }}
                            onClick={() => {
                                navigate(
                                    `${ROUTER.RISK_MANAGEMENT.RA}/${riskId}?tab=3`
                                );
                            }}
                            size="large"
                            ghost
                        >
                            {t('common.Edit')}
                        </Button>
                    </div>
                </div>

                <div className="pb-6 flex items-center">
                    <div className="font-bold">{t('Last Update')} : </div>
                    <span>&nbsp;&nbsp;</span>
                    <div>{detail?.likelihoodUpdateDate || '-'}</div>
                </div>
            </div>

            <div className="grid grid-cols-12 mb-4">
                <div className="col-span-8 my-1 mr-4 box-content p-4">
                    {raDetail ? (
                        <>
                            <div className="text-lg font-bold text-purple pb-2">
                                {lang === 'en'
                                    ? raDetail?.likelihoodTopicNameEn
                                        ? raDetail.likelihoodTopicNameEn
                                        : '-'
                                    : raDetail?.likelihoodTopicNameTh
                                    ? raDetail.likelihoodTopicNameTh
                                    : '-'}
                            </div>
                            {raDetail?.likelihoodLevels?.length > 0
                                ? raDetail?.likelihoodLevels.map(
                                      (itemRisk, i) => (
                                          <div className="flex items-center py-2">
                                              <svg
                                                  width="10"
                                                  height="11"
                                                  viewBox="0 0 10 11"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                              >
                                                  <circle
                                                      cx="5"
                                                      cy="5.5"
                                                      r="5"
                                                      fill={levelColor(
                                                          itemRisk?.mriskLevelPlanId
                                                      )}
                                                  />
                                              </svg>
                                              <span>&nbsp;&nbsp;</span>
                                              <div key={i}>
                                                  {itemRisk?.likelihoodLevelName
                                                      ? itemRisk?.likelihoodLevelName
                                                      : '-'}
                                              </div>
                                          </div>
                                      )
                                  )
                                : '-'}
                        </>
                    ) : (
                        <div className="h-[30vh] flex justify-center items-center">
                            <IconEmpty />
                        </div>
                    )}
                </div>
                <div className="col-span-4">
                    <img src={likeliHoodImpact} alt="LikeliHood Impact" />
                </div>
            </div>

            <div className="table-risk-custom">
                <table
                    style={{
                        width: '100%',
                    }}
                >
                    <thead>
                        <tr>
                            <th colSpan={2}>{t('RA.Definition')}</th>
                            <th>{t('RA.Guidelines')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {definition?.map((e) => (
                            <>
                                <tr>
                                    <td
                                        style={{
                                            background: `${levelColor(
                                                e.levelId
                                            )}`,
                                            color: '#FFF',
                                            fontWeight: '600',
                                            textAlign: 'center',
                                            border: 'none',
                                        }}
                                    >
                                        {lang === 'en' ? e.levelEn : e.levelTh}
                                    </td>
                                    <td>
                                        {lang === 'en'
                                            ? e.levelNameEn
                                            : e.levelNameTh}
                                    </td>
                                    <td>
                                        {lang === 'en'
                                            ? e.descriptionEn
                                            : e.descriptionTh}
                                    </td>
                                </tr>
                            </>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
